export default function setBodyColor({ background, isHome = false }) {
    const root = document.documentElement;
    if (isHome) {
        root.style.setProperty('--background', '#1E293B');
        root.classList.add('home-background');
    } else {
        root.style.setProperty('--background', background);
        root.classList.remove('home-background');
    }
}